<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5 4L5.96447 7.53553L9.5 11.0711" stroke="currentColor" stroke-linecap="round"/>
</svg>
